var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancleCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#f53c17",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2348 5109 c-596 -49 -1164 -314 -1594 -743 -1001 -1002 -1001 -2610 0 -3612 1002 -1001 2610 -1001 3612 0 1001 1002 1001 2610 0 3612 -535 534 -1270 805 -2018 743z m-231 -1651 l443 -443 443 443 c243 243 447 442 452 442 13 0 445 -432 445 -445 0 -5 -199 -209 -442 -452 l-443 -443 443 -443 c243 -243 442 -447 442 -452 0 -13 -432 -445 -445 -445 -5 0 -209 199 -452 442 l-443 443 -443 -443 c-243 -243 -447 -442 -452 -442 -13 0 -445 432 -445 445 0 5 199 209 442 452 l443 443 -443 443 c-243 243 -442 447 -442 452 0 13 432 445 445 445 5 0 209 -199 452 -442z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancleCircle);
export default __webpack_public_path__ + "static/media/cancle-circle.b9e1e197cfb0b6c30992c4171037dcb0.svg";
export { ForwardRef as ReactComponent };